module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "back-button right mb11",
    attrs: {
      "tag": "a",
      "to": "/portfolio"
    }
  }, [_vm._v("Back to portfolio")]), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("COMMUNITY PROJECTS")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "portfolio-list"
  }, [_c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Baltimore Harbor")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Baltimore, MD")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Basque Center")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Boise, ID")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Idaho Elks Hospital")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Boise, ID")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("The Grove Plaza")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Boise, ID")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community5.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Boothbay Animal Hospital")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Boothbay Harbor, ME")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community6.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Boothbay Harbor")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Boothbay Harbor, ME")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community7.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Hospice of Gunnison Valley")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Gunnison, CO ")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community8.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Medford Lakes 9/11 Memorial")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Medford Lakes, NJ")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community9.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Basque Association")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Mountain Home, ID")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community10.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Friends of Hospice")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Nevada City, CA")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community11.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Norquay 100 Committee")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Norquay, Saskatchewan, Canada")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community12.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("San Francisco Zoo")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("San Francisco, CA")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community13.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Noe Valley Recreation Center")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("San Francisco, CA")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community14.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("The Club at Savannah Harbor")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Savannah, GA")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community15.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Star Lions Club")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Star, ID")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "img": "",
      "src": "images/Our-Work-Page/Community-Projects/community16.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "portfolio-list-name"
  }, [_vm._v("Downtown Revitalization")]), _vm._v(" "), _c('span', {
    staticClass: "portfolio-list-location"
  }, [_vm._v("Washington, MO")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2636c907","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/our-work/CommunityProjects.vue
// module id = BgzU
// module chunks = 1